import React from 'react';
import { waLink, WaIcon } from '../App';

export default function Band() {
  return (
    <div style={{ background:'var(--plum)', color:'#fbeee9', textAlign:'center', padding:'74px 26px' }}>
      <h2 style={{ fontSize:'clamp(2.2rem,4.4vw,3.3rem)', color:'#fff' }}>Found a feeling?</h2>
      <p style={{ color:'#f3d9ce', fontSize:18, maxWidth:'46ch', margin:'14px auto 26px' }}>
        Tell us the flavour, the date and the words. We'll bake the rest.
      </p>
      <a href={waLink("Hi Kreme Tops! I saw your gallery and I'd love to order.")} target="_blank" rel="noopener noreferrer"
        style={{ display:'inline-flex', alignItems:'center', gap:9, fontFamily:'var(--sans)', fontWeight:700, fontSize:14.5, padding:'14px 24px', borderRadius:40, background:'#fff', color:'var(--plum-deep)', textDecoration:'none', transition:'background .2s, color .2s' }}
        onMouseOver={e => { e.currentTarget.style.background='var(--gold)'; e.currentTarget.style.color='#fff'; }}
        onMouseOut={e => { e.currentTarget.style.background='#fff'; e.currentTarget.style.color='var(--plum-deep)'; }}>
        <WaIcon />Start your order on WhatsApp
      </a>
    </div>
  );
}
